var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { TableName, DB_NAME, DB_VERSION, } from './Constant';
import Tdatabase, { QueryCondition, QUERY_CONDITION_TYPE } from '@tencent/tdoc-database';
import { FILE_TYPE } from './model/PadInfo';
import { UserInfo } from './model/UserInfo';
import { getCookie, isSupportClientDB, checkDebugOffline, UserAgent, getUserId, } from './tools/utils';
import { Result } from '@tencent/tdoc-database';
import Log from './tools/Log';
import { DBDriver } from '@tencent/tdoc-database';
import { CGI } from '.';
export var MaxIDCount = 50; // 本地最多拉取50个ID
var OfflineDataManager = /** @class */ (function () {
    // testDatabase: ClientDatabase;
    function OfflineDataManager(options) {
        this.options = options;
        if (options && options.businessType !== undefined) {
            this.businessType = options.businessType;
        }
        var uid = getUserId();
        if (options && options.user) {
            this.user = options.user;
        }
        else if (uid) {
            this.user = new UserInfo({ uid: uid });
        }
        else {
            // 临时用户 随意搞一个吧 反正也不能产生编辑数据
            this.user = new UserInfo({ uid: 'guest' });
        }
        Log.log('OfflineDataManager', this.user.getUserId());
    }
    OfflineDataManager.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Tdb, initResult, _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        Tdb = new Tdatabase(DB_NAME, [
                            { tableName: TableName.DOCUMENT_DATA, keyName: 'key', indexs: ['globalPadId', 'secretId', 'type', 'version', 'uid', 'subId', 'chunkId'] },
                            { tableName: TableName.OFFLINE_DATA, keyName: 'key', indexs: ['globalPadId', 'secretId', 'type', 'version', 'uid', 'subId', 'chunkId'] },
                            { tableName: TableName.PAD_INFO, keyName: 'key', indexs: ['globalPadId', 'secretId', 'uid'] },
                            { tableName: TableName.NEW_DOCUMENT_ID, keyName: 'globalPadId' },
                            { tableName: TableName.FOLDER_INFO, keyName: 'key' },
                            { tableName: TableName.USER_INFO, keyName: 'uid' },
                            { tableName: TableName.DOCUMENT_STATUS, keyName: 'globalPadId', indexs: ['globalPadId', 'secretId', 'uid'] },
                            { tableName: TableName.DATA_CHANGE, keyName: 'key' },
                            { tableName: TableName.DocumentEntities, keyName: 'key' },
                            { tableName: TableName.USERS, keyName: 'key', indexs: ['tinyId', 'nowUserIndex', 'docId', 'pageType'] },
                        ], isSupportClientDB() && !checkDebugOffline() ? DBDriver.ClientDB : DBDriver.IndexDB, DB_VERSION);
                        this.database = Tdb.database;
                        return [4 /*yield*/, this.database.init()];
                    case 1:
                        initResult = _g.sent();
                        if (initResult.error) {
                            Log.error(initResult.error);
                            return [2 /*return*/, initResult];
                        }
                        Log.log('init IndexedDB success');
                        if (!(this.businessType === FILE_TYPE.EXCEL)) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this.createHelper(FILE_TYPE.EXCEL)];
                    case 2:
                        _a.excelHelper = _g.sent();
                        return [3 /*break*/, 11];
                    case 3:
                        if (!(this.businessType === FILE_TYPE.WORD)) return [3 /*break*/, 5];
                        _b = this;
                        return [4 /*yield*/, this.createHelper(FILE_TYPE.WORD)];
                    case 4:
                        _b.wordHelper = _g.sent();
                        return [3 /*break*/, 11];
                    case 5:
                        if (!(this.businessType === FILE_TYPE.SLIDE)) return [3 /*break*/, 7];
                        _c = this;
                        return [4 /*yield*/, this.createHelper(FILE_TYPE.SLIDE)];
                    case 6:
                        _c.slideHelper = _g.sent();
                        return [3 /*break*/, 11];
                    case 7:
                        // 不清楚的情况下那就两个都初始化吧  然后getHelper的时候自己指定用哪个就好
                        _d = this;
                        return [4 /*yield*/, this.createHelper(FILE_TYPE.EXCEL)];
                    case 8:
                        // 不清楚的情况下那就两个都初始化吧  然后getHelper的时候自己指定用哪个就好
                        _d.excelHelper = _g.sent();
                        _e = this;
                        return [4 /*yield*/, this.createHelper(FILE_TYPE.WORD)];
                    case 9:
                        _e.wordHelper = _g.sent();
                        _f = this;
                        return [4 /*yield*/, this.createHelper(FILE_TYPE.SLIDE)];
                    case 10:
                        _f.slideHelper = _g.sent();
                        _g.label = 11;
                    case 11: return [2 /*return*/, new Result(undefined, true)];
                }
            });
        });
    };
    OfflineDataManager.prototype.getHelper = function (type) {
        if (typeof (type) === 'undefined') {
            type = this.businessType;
        }
        var helper;
        if (type === FILE_TYPE.EXCEL) {
            helper = this.excelHelper;
        }
        else if (type === FILE_TYPE.WORD) {
            helper = this.wordHelper;
        }
        else if (type === FILE_TYPE.SLIDE) {
            helper = this.slideHelper;
        }
        else {
            throw new Error('没有指定businessType的情况下 getHepler必须明确指定FILE_TYPE来获取对应的helper.');
        }
        return helper;
    };
    OfflineDataManager.prototype.getDatabase = function () {
        return this.database;
    };
    OfflineDataManager.prototype.popDocumentId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, documentId, condition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // 校验下用户ID
                        if (!this.user || !this.user.getUserId()) {
                            return [2 /*return*/, new Result(new Error('UidError'))];
                        }
                        return [4 /*yield*/, this.getDocumentId()];
                    case 1:
                        result = _a.sent();
                        if (!result.error) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.preFetchDocIds()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getDocumentId()];
                    case 3:
                        result = _a.sent();
                        _a.label = 4;
                    case 4:
                        documentId = result.data;
                        if (!documentId) {
                            Log.error({ retcode: -1, reason: 'indexDB has not NewDocumentIds!' });
                            return [2 /*return*/, new Result(new Error('NoAvaliableIdError'))];
                        }
                        condition = QueryCondition.newInstance().addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, documentId.globalPadId);
                        return [4 /*yield*/, this.database.delete(TableName.NEW_DOCUMENT_ID, condition)];
                    case 5:
                        _a.sent();
                        // 创建文档成功的时候异步执行一次预创建，防止本地数量不足
                        this.preFetchDocIds();
                        return [2 /*return*/, new Result(undefined, documentId)];
                }
            });
        });
    };
    OfflineDataManager.prototype.preFetchDocIds = function () {
        return __awaiter(this, void 0, void 0, function () {
            var condition, queryResult, documentIds, preFetchUrl, result, data, resultList, idInfoList, preFetchIdInfo, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = QueryCondition.newInstance();
                        condition.addCondition('isCreated', QUERY_CONDITION_TYPE.ONLY, false);
                        return [4 /*yield*/, this.database.getAll(TableName.NEW_DOCUMENT_ID, condition)];
                    case 1:
                        queryResult = _a.sent();
                        if (queryResult.error) {
                            return [2 /*return*/, queryResult];
                        }
                        documentIds = queryResult.data;
                        // 如果剩下的还大于50的一半  那就不拉取了  截留一下
                        if (documentIds && documentIds.length > MaxIDCount * 0.5) {
                            // this.preCreateDefaultClientVars(documentIds);
                            return [2 /*return*/, new Result(new Error('ID还剩下超过一半，不用拉新的了。'), { count: documentIds.length })];
                        }
                        preFetchUrl = 'https://docs.qq.com/cgi-bin/online_docs/predocid_get';
                        return [4 /*yield*/, CGI.sendCommonRequest(preFetchUrl)];
                    case 2:
                        result = _a.sent();
                        if (result.error) {
                            // 拉取异常
                            return [2 /*return*/, result];
                        }
                        data = result.data;
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 6, , 7]);
                        if (!(data.retcode === 0)) return [3 /*break*/, 5];
                        resultList = data.doc_id_list.splice(0, MaxIDCount);
                        idInfoList = resultList.map(function (item) { return ({
                            globalPadId: item.domain_id + "$" + item.pad_id,
                            localPadId: "" + item.pad_id,
                            secretId: "" + item.encoded_doc_id,
                            isCreated: false,
                            padType: FILE_TYPE.UNKNOWN,
                        }); });
                        preFetchIdInfo = idInfoList.map(function (item) {
                            return {
                                tableName: TableName.NEW_DOCUMENT_ID,
                                data: item,
                            };
                        });
                        return [4 /*yield*/, this.database.updateMultiTableData(preFetchIdInfo)];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5:
                        Log.error('后台retCode不为0');
                        return [2 /*return*/, new Result(new Error(''))];
                    case 6:
                        e_1 = _a.sent();
                        Log.error(e_1, '处理数据异常');
                        return [2 /*return*/, new Result(e_1)];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 检测环境是否有变化
     */
    OfflineDataManager.prototype.checkEvn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lastRouteid, lastFd, routeid, fd;
            return __generator(this, function (_a) {
                lastRouteid = localStorage.getItem('last_dev_route_id');
                lastFd = localStorage.getItem('last_fd');
                routeid = getCookie('dev_route_id');
                fd = getCookie('fd');
                if (lastRouteid !== routeid || lastFd !== fd) {
                    this.setEvn(routeid, fd);
                    return [2 /*return*/, true];
                }
                this.setEvn(routeid, fd);
                return [2 /*return*/, false];
            });
        });
    };
    OfflineDataManager.prototype.setEvn = function (routeid, fd) {
        localStorage.setItem('last_dev_route_id', routeid);
        localStorage.setItem('last_fd', fd);
    };
    OfflineDataManager.prototype.mapDocumentVersion = function (dver, url) {
        var _a, _b;
        Log.debug("mapDocumentVersion  " + url + ":" + dver);
        var data = { url: url, dver: dver };
        var success = function (resp) {
            Log.info("mapDocumentVersion " + JSON.stringify(resp));
        };
        if (UserAgent.isDesktop) {
            this.sendCommandToSW({
                type: 'preload-map-document-version',
                data: data,
            });
        }
        else if ((_a = global.tdocs) === null || _a === void 0 ? void 0 : _a.mapDocumentVersion) {
            global.tdocs.mapDocumentVersion(__assign(__assign({}, data), { success: success }));
        }
        else {
            (_b = window.mqq) === null || _b === void 0 ? void 0 : _b.invoke('docx', 'mapDocumentVersion', data, success);
        }
    };
    OfflineDataManager.prototype.removeDocumentVersion = function (url) {
        var _a, _b;
        Log.debug("removeDocumentVersion " + url);
        var success = function (resp) {
            Log.info("removeDocumentVersion " + JSON.stringify(resp));
        };
        if (UserAgent.isDesktop) {
            this.sendCommandToSW({
                type: 'preload-remove-document-version',
                data: url,
            });
        }
        else if ((_a = global.tdocs) === null || _a === void 0 ? void 0 : _a.removeDocumentVersion) {
            global.tdocs.removeDocumentVersion({
                url: url,
                success: success,
            });
        }
        else {
            (_b = window.mqq) === null || _b === void 0 ? void 0 : _b.invoke('docx', 'removeDocumentVersion', { url: url }, success);
        }
    };
    OfflineDataManager.prototype.sendCommandToSW = function (command) {
        if (!navigator.serviceWorker.controller) {
            Log.error('service worker is not available');
            return;
        }
        Log.debug("send command to service worker " + JSON.stringify(command));
        navigator.serviceWorker.controller.postMessage(command);
    };
    OfflineDataManager.prototype.createHelper = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            var helperOptions, _a, WordHelper, ExcelHelper, SlideHelper;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        helperOptions = {
                            parent: this,
                            database: this.database,
                        };
                        _a = type;
                        switch (_a) {
                            case FILE_TYPE.WORD: return [3 /*break*/, 1];
                            case FILE_TYPE.EXCEL: return [3 /*break*/, 3];
                            case FILE_TYPE.SLIDE: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, import(/* webpackChunkName: "bundle_word-helper" */ './helper/WordHelper')];
                    case 2:
                        WordHelper = (_b.sent()).WordHelper;
                        return [2 /*return*/, new WordHelper(helperOptions)];
                    case 3: return [4 /*yield*/, import(/* webpackChunkName: "bundle_excel-helper" */ './helper/ExcelHelper')];
                    case 4:
                        ExcelHelper = (_b.sent()).ExcelHelper;
                        return [2 /*return*/, new ExcelHelper(helperOptions)];
                    case 5: return [4 /*yield*/, import(/* webpackChunkName: "bundle_slide-helper" */ './helper/SlideHelper')];
                    case 6:
                        SlideHelper = (_b.sent()).SlideHelper;
                        return [2 /*return*/, new SlideHelper(helperOptions)];
                    case 7: return [2 /*return*/, undefined];
                }
            });
        });
    };
    OfflineDataManager.prototype.getDocumentId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var condition;
            return __generator(this, function (_a) {
                condition = QueryCondition.newInstance();
                condition.addCondition('isCreated', QUERY_CONDITION_TYPE.ONLY, false);
                return [2 /*return*/, this.database.get(TableName.NEW_DOCUMENT_ID, condition)];
            });
        });
    };
    return OfflineDataManager;
}());
export { OfflineDataManager };
// 本地测试使用
// (<any>window).testOfflineDataManager = new OfflineDataManager({ businessType: FILE_TYPE.WORD });
//# sourceMappingURL=OfflineDataManager.js.map